import { supabase } from "@/integrations/supabase/client";

export type MaintenanceState = {
  enabled: boolean;
  message: string;
  starts_at: string | null;
  ends_at: string | null;
  announce_from: string | null;
  updated_at: string;
  updated_by: string | null;
};

export async function fetchMaintenanceState() {
  return supabase
    .from("app_maintenance")
    .select("enabled, message, starts_at, ends_at, announce_from, updated_at, updated_by")
    .eq("id", true)
    .maybeSingle();
}

export type MaintenanceUpdate = {
  enabled: boolean;
  message: string;
  starts_at: string | null;
  ends_at: string | null;
  announce_from: string | null;
};

export async function updateMaintenanceState(update: MaintenanceUpdate, userId: string | null) {
  return supabase
    .from("app_maintenance")
    .update({ ...update, updated_by: userId })
    .eq("id", true)
    .select()
    .maybeSingle();
}

export async function fetchIsSupportAdmin(userId: string) {
  return supabase
    .from("support_admins")
    .select("user_id")
    .eq("user_id", userId)
    .maybeSingle();
}
